import { useMediaQuery } from "@mui/material";

/**
 * 画面幅が768px以上（PC表示）かどうかを判定するカスタムフック
 * - true: デスクトップ（768px以上）
 * - false: スマホ（768px未満）
 */
export const useIsDesktop = () => {
  return useMediaQuery("(min-width:768px)");
};
